import type { BoardPoint, BoardSize, StoneColor } from '@wx-weiqi/contracts';
import { researchStoneLabels } from './fox-kifu-presentation';

/** Presentation preferences only; never changes the authoritative move history. */
export type ClassroomMarkerMode = 'LAST_ONE' | 'LAST_FIVE' | 'LAST_TEN' | 'ALL' | 'CUSTOM';

export const CLASSROOM_MARKER_LABELS: Readonly<Record<ClassroomMarkerMode, string>> = {
  LAST_ONE: '最后1手',
  LAST_FIVE: '最后5手',
  LAST_TEN: '最后10手',
  ALL: '全部手数',
  CUSTOM: '自定义',
};

export function parseClassroomMarkerCount(value: string): number | null {
  if (!/^\d+$/u.test(value.trim())) return null;
  const count = Number(value);
  return Number.isSafeInteger(count) && count > 0 ? count : null;
}

export function classroomMarkerLabel(mode: ClassroomMarkerMode, customCount: number): string {
  return mode === 'CUSTOM' ? `最后${customCount}手` : CLASSROOM_MARKER_LABELS[mode];
}

export function classroomVisibleMarkers<T>(
  candidates: readonly T[],
  mode: ClassroomMarkerMode,
  customCount: number,
): readonly T[] {
  if (mode === 'ALL') return candidates;
  const count =
    mode === 'CUSTOM' ? customCount : mode === 'LAST_TEN' ? 10 : mode === 'LAST_FIVE' ? 5 : 1;
  return candidates.slice(-Math.max(1, Number.isSafeInteger(count) ? count : 1));
}

/** Keep original variation numbers, even after captures, point reuse or rewinding. */
export function classroomResearchStoneLabels(
  moves: readonly BoardPoint[],
  stones: readonly (StoneColor | null)[],
  size: BoardSize,
  mode: ClassroomMarkerMode,
  customCount: number,
) {
  const firstVisible = moves.length - classroomVisibleMarkers(moves, mode, customCount).length;
  return researchStoneLabels(moves, stones, size).filter(
    ({ label }) => Number(label) > firstVisible,
  );
}
